module.exports = __webpack_public_path__ + "img/THData.f82742fa.png";